import React, { FC } from "react";
import { ISpinnerStyles, Spinner, SpinnerSize } from "@fluentui/react";

export const spinnerStyles: ISpinnerStyles = {
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
};
interface LoadingSpinnerProps {
  loading: boolean;
}

// @ts-ignore
export const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  loading,
  children,
}) => {
  if (loading) {
    return (
      <Spinner
        role="alert"
        aria-busy={true}
        ariaLabel="spinner"
        styles={spinnerStyles}
        size={SpinnerSize.large}
      />
    );
  }
  return children ?? null;
};
